// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

interface DownloadableFile {
  adminUpload?: boolean;
  autonomous?: boolean;
}

interface DownloadGateProject {
  imageryRequest?: object;
  isDemoProject?: boolean;
  restrictFileDownload?: boolean;
}

// The Data Sets panel's input-file download gate, verbatim: demo projects,
// ops trainers and restricted orgs never download; on imagery-request projects
// AirWorks-supplied files (adminUpload, and autonomous for tifs) are withheld.
export const canDownloadFile = (
  kind: FileSelectionKind,
  file: DownloadableFile,
  project: DownloadGateProject | null | undefined,
  opsTrainer: boolean,
): boolean => {
  // Pano and pole-image zips mirror their panel rows, which render download
  // buttons unconditionally.
  if (kind === 'pano' || kind === 'poleImage') return true;
  if (!project || project.isDemoProject || opsTrainer || project.restrictFileDownload) return false;
  if (!project.imageryRequest) return true;
  return kind === 'tif' ? !file.adminUpload && !file.autonomous : !file.adminUpload;
};

export default canDownloadFile;
